import React, { useEffect, useState } from "react";
import AsyncAutoComplete from "components/shared/asyncAutoComplete";
import styles from "../Tasks.module.scss";
import { useUserOptions } from "components/hooks/useUsersOptions";
import { makeQueryString } from "utils/utils";
import { USER } from "services/apiEndpoints";
import { privateGet } from "services/privateRequest";


export const AssignToFilterContainer = ({
  onSelectedUser,
   id, 
  height,
   customStyles,
   defaultValue = {
    label:'',
    value:''
   },
   label = true, 
   isDefSelect = true, 
   width, 
   name, 
   selectedOption ,
   placeholder,
  }) => {
  const { onSelectedOptionChange, ...options } = useUserOptions();
  const [users, setUsers] = useState([])
  // const [selectedUser,setSelectedUser] = useState({})

  const onSelectedAssignToOptionChange = (event, newValue) => {
    id?.toString() ? onSelectedUser(id, newValue) : onSelectedUser(newValue);
  };
  const fetchUserOptions = async (payload) => {
    try {
      const queryString = makeQueryString(USER, payload);
      const { data } = await privateGet(queryString);
      const responseOptions = data?.data?.responses?.map((user) => {
        return {
          label: `${user?.firstName} ${user?.lastName}`,
          value: user?._id,
        };
      });
      setUsers(responseOptions);
    } catch (error) {
      console.log('error', error)
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      await fetchUserOptions({
        pageNumber: 1,
        limit: 100,
      });
    };
      fetchData();
  }, []); // Fetch only on mount
  useEffect(() => {
    if (users.length && selectedOption) {
      const prefilledOption = users.find((e) => e.value == selectedOption);
      if (prefilledOption) {
        onSelectedUser(prefilledOption, true); // Update the state with found option
      }
    }
  }, [users, selectedOption]); // Run only when `users` or `selectedOption` changes

  return (
    <div className={styles.teamFilterContainer}>
      <AsyncAutoComplete
        name={name}
        {
        ...(
          isDefSelect ? { selectedOption: users.length > 0 ? users.find((e) => e.value == selectedOption) : null } : {}
        )
        }
        customStyles={customStyles}
        placeholder={placeholder}
        defaultValue={defaultValue}
        label={label ? "Assigned To" : ""}
        width={width || 220}
        height={height}
        onSelectedOptionChange={onSelectedAssignToOptionChange}
        {...options}
      />
    </div>
  );
};
